import { Component } from '@angular/core';
import { NavParams, ViewController, LoadingController, ToastController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../services/users/users-service';
import { User } from '../../models/user';
import { UserEmailExistsValidator } from '../../validators/user-email-exists';

@IonicPage()
@Component({
  selector: 'page-edit-user-modal',
  templateUrl: 'edit-user-modal.html',
})
export class EditUserModalPage {
  public User: User;
  public ShadowUser: User;
  private name: string;
  private email: string;
  private role: string;
  public userForm: FormGroup;
  public isCordova: boolean;
  public selectOptions: any = { cssClass: null };

  ionViewDidLoad() {

    // Define custom select classes if
    // not in mobile env.
    this.selectOptions.cssClass = this.isCordova ? null : 'extra-wide';
  }

  shadow() {
    let a: string;
    let attribs: object = this.User.get();

    for(a in attribs)
    {
      attribs[a] = this.User.get(a);
    }

    this.ShadowUser = new User(attribs);
  }

  save(userForm) {
    let u: string;

    for(u in userForm)
    {
      if(userForm[u] === this.User.get(u))
      {
        delete userForm[u];
      }
    }

    if(Object.keys(userForm).length === 0)
    {
      return this.close();
    }

    let loading = this.loadingCtrl.create({
      content: "Saving..."
    });

    loading.present();

    let self: EditUserModalPage = this;
    this.usersService.update(this.User.get("id"),userForm)
      .subscribe(
        res => {
          loading.dismiss();

          self.User = new User(res);

          let toast = this.toastCtrl.create({
            message: `${self.User.get("name")}'s account was successfully updated.`,
            duration: 6000,
            position: "top"
          });

          toast.present();

          self.close();
        },
        rej => {
          loading.dismiss();

          let toast = this.toastCtrl.create({
            message: rej.error.message,
            duration: 8000,
            position: "top"
          });

          toast.present();
        }
      );
  }

  close() {
    this.viewCtrl.dismiss(this.User);
  }

  cancel() {
    this.viewCtrl.dismiss(this.ShadowUser);
  }

  constructor(private navParams: NavParams,
    private viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    private emailExistsValidator: UserEmailExistsValidator,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private platform: Platform,
    private usersService: UsersService
    ) {

      // Identify if this is browser or device.
      this.isCordova = this.platform.is('cordova');

      this.User = this.navParams.get("user");

      this.shadow();

      this.name = this.User.get("name");
      this.email = this.User.get("email");
      this.role = this.User.get("roles")[0].name

      this.userForm = this.formBuilder.group({
          name: [ this.name,
                  Validators.compose([Validators.minLength(8), Validators.maxLength(120), Validators.pattern(/^[a-zA-Z\s\-]*$/), Validators.required])
                ],
          email:[ this.email,
                  Validators.compose([Validators.required]),
                  this.emailExistsValidator.excludeId(this.User.get("id")).checkEmail.bind(this.emailExistsValidator)
                ],
          role: [ this.role,
                  Validators.compose([Validators.required])
                ]
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/edit-user-modal/edit-user-modal.ts